export const VALID_BUTTON_STYLES = ['blue', 'green', 'bright-green']
export const VALID_BUTTON_TEXT_STYLES = ['default', 'large']
